module.exports = __webpack_public_path__ + "img/Paladin-dwarf-f-70.cc5d8c04.gif";